/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import { mountModal } from 'lib/modal';
import ConfirmDialog from 'components/ConfirmDialog';
import Glyph from 'components/Glyph';
import MediaObject from 'components/MediaObject';
import Menu from 'components/Menu';
import MenuButton from 'components/MenuButtonDeprecated';
import MenuItem from 'components/MenuItem';
import Text from 'components/Text';
import ToastActions from 'actions/ToastActions';
import UserAvatar from 'users/components/UserAvatar';

import './styles/UserParentChildRow.scss';

type MinimalRelatedUser = {
  id: Backbone$Id,
  name: string,
  initials: string,
};

type Props = {
  viewingUserId: ?number,
  relation: 'parent' | 'child',
  relatedUser: MinimalRelatedUser,
  pending?: boolean,
  removeRelation: (parentId: ?Backbone$Id, childId: ?Backbone$Id) => Promise<*>,
  onDelete: () => void,
};

class UserParentChildRow extends React.Component<Props, $FlowFixMeState> {
  state = {};

  confirmRemoveRelation = () => {
    const modal = (
      <ConfirmDialog
        title={`Are you sure you want to remove ${this.props.relatedUser.name} as your ${this.props.relation}?`}
        onConfirm={this.removeRelation}
      />
    );
    mountModal(modal, this);
  };
  removeRelation = () => {
    const otherId = this.props.relatedUser.id;
    const selfId = this.props.viewingUserId;
    const parentId = this.props.relation === 'child' ? selfId : otherId;
    const childId = this.props.relation === 'child' ? otherId : selfId;

    if (parentId && childId) {
      this.props
        .removeRelation(parentId, childId)
        .then(() => {
          this.props.onDelete();
          ToastActions.showSuccessToast(`A ${this.props.relation} has been removed.`);
        })
        .catch(e => {
          console.error(`Removing ${this.props.relation} relation failed`, e);
          ToastActions.showAPIError(e);
        });
    }
  };
  renderMenu() {
    const removeText = this.props.relation === 'parent' ? 'Remove parent' : 'Remove child';
    return (
      <Menu>
        <MenuItem onClick={this.confirmRemoveRelation}>
          <Glyph name="close" />
          {removeText}
        </MenuItem>
      </Menu>
    );
  }

  render = () => {
    const { relatedUser, pending } = this.props;
    const textColor = this.props.pending ? 'graphite' : 'chalkboard';

    return (
      <tr className="UserParentChildRow">
        <td>
          <MediaObject gutter="small" className="UserParentChildRow-name">
            <UserAvatar size="medium" user={relatedUser} />
            <Text element="div" color={textColor}>
              {relatedUser.name}
            </Text>
            {pending && (
              <Text element="div" color={textColor}>
                Pending
              </Text>
            )}
          </MediaObject>
        </td>
        <td>
          <MenuButton
            alignment="right"
            placement="bottom"
            menu={this.renderMenu()}
            size="small"
            level="icon">
            <Glyph name="ellipses" solo />
          </MenuButton>
        </td>
      </tr>
    );
  };
}

const withMutations = graphql(
  gql`
    mutation removeParent($input: RemoveParentRelationshipInput!) {
      removeParentRelationship(input: $input) {
        error {
          message
        }
      }
    }
  `,
  {
    props({ mutate }) {
      return {
        removeRelation(parentId: ?number, childId: ?number) {
          const input = {
            parent_id: parentId,
            child_id: childId,
          };
          return mutate({ variables: { input } });
        },
      };
    },
  }
);

export { UserParentChildRow };
export default withMutations(UserParentChildRow);
